// extracted by mini-css-extract-plugin
export default {"loader":"LoadingAnimation_loader__b8ete","big":"LoadingAnimation_big__I8GCf"};